import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      "fill-rule": "evenodd",
      d: "M12 12.854c1.399 0 2.533 1.174 2.533 2.623 0 1.448-1.134 2.623-2.533 2.623s-2.533-1.175-2.533-2.623 1.134-2.623 2.533-2.623m1.233 2.623c0-.706-.552-1.277-1.233-1.277s-1.233.571-1.233 1.277c0 .705.552 1.277 1.233 1.277s1.233-.572 1.233-1.277",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      "fill-rule": "evenodd",
      d: "M7.252 2C5.808 2 4.637 3.212 4.637 4.708q0 .255.07.488C3.712 5.55 3 6.526 3 7.676c0 1.236.825 2.272 1.935 2.55l.77 8.353C5.883 20.52 7.456 22 9.337 22h5.326c1.88 0 3.454-1.48 3.632-3.42l.77-8.353C20.175 9.948 21 8.912 21 7.676c0-1.264-.862-2.318-2.01-2.568q.045-.192.045-.4c0-1.496-1.17-2.708-2.614-2.708zM5.937 4.708c0-.752.589-1.362 1.315-1.362h9.169c.726 0 1.315.61 1.315 1.362 0 .19-.15.344-.333.344H6.27a.34.34 0 0 1-.332-.344m11.816 5.591H6.248l.75 8.153c.116 1.248 1.128 2.202 2.34 2.202h5.325c1.211 0 2.224-.954 2.339-2.202zM19.7 7.676c0 .694-.534 1.258-1.2 1.277h-13c-.666-.019-1.2-.583-1.2-1.277 0-.705.552-1.277 1.233-1.277h12.934c.681 0 1.233.572 1.233 1.277",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }